import { render, staticRenderFns } from "./InfoBar.vue?vue&type=template&id=7b006183"
import script from "./InfoBar.vue?vue&type=script&lang=js"
export * from "./InfoBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ScAddressLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/AddressLink.vue').default,ScPhoneLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/PhoneLink.vue').default,ScViberLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/ViberLink.vue').default,ScWhatsappLink: require('/opt/build/repo/node_modules/@evince/site/lib/packages/WhatsappLink.vue').default})
